import { Link } from 'react-router-dom'

import { OUTRO } from '../../content'
import { anim } from '../../motion'
import { Check, Shape } from '../../primitives'
import { Line, Words } from '../kit'

// Die Formen blühen aus der Mitte auf, Lena ist im Team, danach der Abschluss
const KINDS = ['tri', 'sq', 'dot']
const TONES = ['#FFFFFF', 'yellow', 'green', 'pink']
const GOLDEN = 2.39996

const BLOOM = Array.from({ length: 42 }, (_, i) => {
  const angle = i * GOLDEN
  const dist = 22 + ((i * 37) % 30)
  return {
    kind: KINDS[i % 3],
    color: TONES[i % 4],
    x: Math.cos(angle) * dist * 1.25,
    y: Math.sin(angle) * dist * 0.85,
    r: ((i * 47) % 120) - 60,
    size: 18 + ((i * 11) % 34),
    at: [0.04 + (i % 7) * 0.012, 0.3 + (i % 7) * 0.012]
  }
})

export default function CinFinale() {
  const toTop = () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' })
  }

  return (
    <div className='cin-full cin-finale'>
      {BLOOM.map((b, i) => (
        <div
          key={i}
          className='cin-bloom'
          style={{
            left: `calc(50% + ${b.x}cqw)`,
            top: `calc(50% + ${b.y}cqh)`
          }}
        >
          <div
            style={anim({
              at: b.at,
              out: [0.56, 0.66],
              x: -b.x * 9,
              y: -b.y * 6,
              s: 0.1,
              r: b.r * 3,
              oy: 0
            })}
          >
            <Shape kind={b.kind} color={b.color} size={b.size} rotate={b.r} />
          </div>
        </div>
      ))}

      <div
        className='cin-finale__hello'
        style={anim({ at: [-1, 0], out: [0.56, 0.64], oy: -60 })}
      >
        <div
          className='cin-finale__pair'
          style={anim({ at: [0.1, 0.24], s: 0.5, y: 40 })}
        >
          <span
            className='cin-orb cin-orb--sm'
            style={{ background: 'var(--ink)' }}
          >
            M
          </span>
          <span
            className='cin-orb cin-orb--sm'
            style={{ background: 'var(--pink)' }}
          >
            L
          </span>
        </div>
        <h2 className='cin-display cin-display--white'>
          <Words
            text='Willkommen im Team, Lena.'
            at={[0.14, 0.36]}
            dim={0.25}
          />
        </h2>
        <Line at={[0.34, 0.42]} y={20} className='cin-finale__sub'>
          Customer Success Managerin. Gefunden über das Kreuzmatching.
        </Line>
      </div>

      <div
        className='cin-finale__outro'
        style={anim({ at: [0.66, 0.76], y: 60 })}
      >
        <h2 className='cin-title'>{OUTRO.title}</h2>
        <ul className='cin-finale__list'>
          {OUTRO.points.map((p) => (
            <li key={p}>
              <Check size={24} color='#fff' />
              {p}
            </li>
          ))}
        </ul>
        <div className='cin-finale__actions'>
          <Link to={OUTRO.primary.to} className='cin-cta'>
            {OUTRO.primary.label}
          </Link>
          <button
            type='button'
            onClick={toTop}
            className='cin-cta cin-cta--ghost'
          >
            {OUTRO.secondary}
          </button>
        </div>
      </div>
    </div>
  )
}
